import React, { Component } from "react";
import PropTypes from "prop-types";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { Form, Button } from "semantic-ui-react";
import FormStore from "~/stores/FormStore";
import { getValidationErrors } from "~/utils/ReactReformed/ValidateSchema";

export const validationSchema = {
  amount: {
    required: true,
    isInt: true,
  },
  description: {
    required: true,
  },
};

@observer
class CreditAccountForm extends Component {
  @observable formStore = null;

  constructor(props) {
    super(props);
    this.resetForm();
  }

  onSubmit() {
    const { onSubmit } = this.props;
    const {
      model: { amount, description },
    } = this.formStore;

    const actualAmount = parseInt(amount, 10);
    const actualDescription = description.trim();

    const promise = onSubmit({ amount: actualAmount, description: actualDescription });

    if (promise && typeof promise.then !== "undefined") {
      promise.then(() => {
        this.resetForm();
      });
    }
  }

  resetForm() {
    this.formStore = new FormStore({ amount: "", description: "" });
  }

  render() {
    const { onSubmit, ...rest } = this.props;
    const { model, blurred, onChange } = this.formStore;
    const errors = getValidationErrors(validationSchema, model);

    return (
      <Form onSubmit={() => this.onSubmit()} {...rest}>
        <Form.Group inline>
          <Form.Field
            control={Form.Input}
            label="amount"
            name="amount"
            value={model.amount}
            onChange={onChange}
            style={{ width: "100px" }}
            error={!errors.fields.amount.isValid && blurred.amount}
          />
          <Form.Field
            control={Form.Input}
            label="description"
            name="description"
            value={model.description}
            onChange={onChange}
            style={{ width: "400px" }}
            error={!errors.fields.description.isValid && blurred.description}
          />
          <Button primary disabled={!errors.isValid} type="submit" style={{ position: "relative", top: "10px" }}>
            Add
          </Button>
        </Form.Group>
      </Form>
    );
  }
}

CreditAccountForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default CreditAccountForm;
